import { DFDHeadersObject } from 'modules/types/common';
import { ANDROID_LOCALHOST } from 'modules/utils/UrlUtils';
import { DFDHeaders } from 'serverTypes/authentication';
import DeviceInfoServices from 'services/DeviceInfoServices';
import { currentAccountConsumerIdSelector } from 'store/account/selectors';
import { apiKeySelector } from 'store/appSettings/selectors';
import { dfdAccessTokenSelector, fhirCurrentUserPatientId } from 'store/authentication/selectors';
import { RootState } from 'store/types';

export const getDownloadHeadersWithCurrentAccountConsumerId = (state: RootState, url = '') => {
  const patientId = fhirCurrentUserPatientId(state);
  const accessToken = dfdAccessTokenSelector(state);
  const apikey = apiKeySelector(state);
  const consumerId = currentAccountConsumerIdSelector(state);
  const deviceId = DeviceInfoServices.getDeviceId();

  const headers: DFDHeadersObject = {
    [DFDHeaders.authorization]: `Bearer ${accessToken}`,
    [DFDHeaders.apiKey]: apikey,
    [DFDHeaders.mobileDeviceId]: deviceId,
    [DFDHeaders.consumerId]: consumerId,
    [DFDHeaders.patientId]: patientId
  };

  if (
    process.env.BUILD_ENV !== 'PROD' &&
    (url.includes('localhost') || url.includes(ANDROID_LOCALHOST))
  ) {
    delete headers[DFDHeaders.apiKey];
    headers[DFDHeaders.apiKeyLocalhost] = apikey;
  }

  return headers;
};
